export const AUTH_TOKEN = 'auth-token'
export const REFRESH_TOKEN = 'refresh-token'
